(ns client-portal.client.vi.components.tag
  (:require [client-portal.client.voice-insights.tag-data :as tag.d]
            [client-portal.client.vi.components.tag-icon :as tag-icon]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.icon :as icon]
            [shared.core.style :as style]
            [shared.core.util :as util]
            [clojure.string :as s]))

(defn tag->display-name [{:keys [name value]}]
  (let [name? (util/not-blank-string? name)
        value? (util/not-blank-string? value)
        words (str (when name? (some-> (util/->capitalize-words name)
                                       (s/replace "User Sentiment" "Session Sentiment")))
                   (when (and name? value?) ": ")
                   (when value? (util/->capitalize-words value)))]
    (->> (s/split (-> words
                      (s/replace "Add On" "Add-On")
                      (s/replace "Ces Score" "CES")
                      (s/replace "Crew CES" "CES")
                      (s/replace "/ " "/")
                      (s/replace "( " "("))
                  " ")
         (mapv (fn [w]
                 (condp = w
                   "Ces" "CES"
                   "Ai" "AI"
                   "Cant" "Can't"
                   "Lto" "LTO"
                   w)))
         (s/join " "))))

(defn utterance-tag-pill [{:keys [name count hide-name? show-description? description icon-type children style] :as tag}]
  (let [outcome-child (some->> children
                               (filter #(= (some-> (:name %) (s/lower-case)) "outcome"))
                               (first))
        icon-type (or icon-type (when outcome-child (tag-icon/get-outcome-material-icon-type (:value outcome-child))))]
    [alc/tooltip
     {:target-content [:div {:style (merge {:display :flex
                                            :align-items :center
                                            :padding "0px 6px"
                                            :border-radius 3
                                            :background-color (util/hex->rgba
                                                                (tag.d/utterance-tag-name->color name)
                                                                0.3)}
                                           style)}
                       [:span {:style {:color (style/alc-color "Text/primary")
                                       :font-size 12
                                       :font-weight style/font-regular-weight
                                       :line-height 1.5
                                       :display :inline
                                       :align-items :center}}
                        (tag->display-name (if hide-name? (dissoc tag :name) tag))
                        (when (some-> count (> 1))
                          [:span {:style {:font-weight style/font-bold-weight
                                          :margin-left 2}}
                           (str " ∙ " count)])
                        (when icon-type
                          [icon/material-icon {:icon-type icon-type
                                               :style {:color (style/alc-color "Text/primary")
                                                       :font-size 12
                                                       :margin-left 3
                                                       :transform "translateY(2px)"}}])]]
      :tooltip-content (when show-description?
                         (let [desc (or description (tag.d/tag->description tag))
                               desc? (not-empty desc)
                               filtered-children (filter #(not-empty (:value %)) children)
                               children? (not-empty filtered-children)]
                           (when (or desc? children?)
                             [:div {:style {:display :flex
                                            :flex-direction :column
                                            :gap 8}}
                              (when desc?
                                [:div
                                 [:div {:style {:font-weight style/font-semi-bold-weight}}
                                  "Description"]
                                 [:div desc]])
                              (when children?
                                [:div
                                 [:div {:style {:font-weight style/font-semi-bold-weight}}
                                  "Child Tags"]
                                 (->> filtered-children
                                      (mapv (fn [child]
                                              [:div (tag->display-name child)]))
                                      (into [:div {:style {:display :flex
                                                           :flex-direction :column
                                                           :gap 1}}]))])])))
      :distance 3}]))

(defn conversation-tag-pill [tag]
  [utterance-tag-pill (assoc tag :style {:background-color (util/hex->rgba
                                                             (tag.d/conversation-tag-name->color (:name tag))
                                                             0.3)})])

(defn sentiment-face [{:keys [size sentiment]}]
  [:svg {:width size :height size :style {:opacity 0.6} :view-box (condp = sentiment
                                                                    "positive" "0 0 16 16"
                                                                    "negative" "32 0 16 16"
                                                                    "16 0 16 16")}
   [:use {:xlink-href "/images/sentiment.svg"}]])
